
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91participant_93WqSrRUdoHR5juCm_7gJVwpsaskor_450LUUkRGXhm66bgMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/form/[event]/participant/[participant].vue?macro=true";
import { default as _91event_934lf2nv_45Mh7kp6Np5pilumDQSbCLCejV4OgqZtrabxz8Meta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/form/[event].vue?macro=true";
import { default as _91signature_93w292OTzya_h9ybNUMwmJwl4ptvhCCv_4561UedZj_A6EIMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/form/signatures/[signature].vue?macro=true";
import { default as formMe_RNGdmCo_45hLmS1bDdd8QQnuaNjYiUfI9Ie2Xw3hZEMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/form.vue?macro=true";
import { default as indexljyGdTjWPwrJq60tDBBsUv4iHGobHuIYY8b_j6vOwrAMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/index.vue?macro=true";
import { default as mailBaseDataLtyXHIXy0m5QKqQEJzSa_eXKP5JUyefoUZBypyuxu6EMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/mails/[id]/mailBaseData.vue?macro=true";
import { default as mailActivitiesJcNxaQi1QuTVvcUHjGg4o7g4Ygzx5pxtcWB8JCiF8nIMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/mails/[id]/mailActivities.vue?macro=true";
import { default as _91id_93xGy0S8UpvsC8KL_9PLAKZpxpT_45wQQo_rWXPnXV_454o4kMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/mails/[id].vue?macro=true";
import { default as indexWG5ImDQkUdyk7O_45TkFMlPXFcz7W9tnOsNYZu1UKoPAsMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/mails/index.vue?macro=true";
import { default as mails1F4sS5lR2v4RQ5dc7OVGn9EMui2YESb3S3hxAXkU4VsMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/mails.vue?macro=true";
import { default as eventMails4VzSNklcPo9SMPfCest_xj8RnPauN5ogswIXQ3Rp5swMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id]/eventMails.vue?macro=true";
import { default as eventLeaders0kyW6jKT_4XPNa52HmqlUaUtVYOFJnkUKuoIYdHm3NIMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id]/eventLeaders.vue?macro=true";
import { default as eventBaseDatabFFi_yStBfHC9vD4bZoq_RgluAoKlk3PGZMe6q4KBzIMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id]/eventBaseData.vue?macro=true";
import { default as eventQuestionsa8poYa3bwsL1HL62W_SoZSVgFLR40r0OcglgoG4vR_45YMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id]/eventQuestions.vue?macro=true";
import { default as eventActivities92ZXo6RcBmS1bTNSpdMMh80k2d2JUxsUKw_45FSUTvPVcMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id]/eventActivities.vue?macro=true";
import { default as eventParticipants1KCeokhyiGwnhUero_PP7t8ocQS3y_kHvDaekbTJXrwMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id]/eventParticipants.vue?macro=true";
import { default as eventCrisisManagersj66Y7vsnlqKFxlthZors2F2sJzEn_45NS50CL6q98PdscMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id]/eventCrisisManagers.vue?macro=true";
import { default as eventParticipantGroupshBrAzZJD3vZSG5dD_aqFPMdpPRc1O8DhjqWC8cfDAHQMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id]/eventParticipantGroups.vue?macro=true";
import { default as eventTemporaryAccesseskS5JIpouCJEZaQtPvhj6edM4iPqENxcs_45SqJPyrHLFwMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id]/eventTemporaryAccesses.vue?macro=true";
import { default as _91id_93up_aCm91BhgPW7L1ztTx7j22YSyof9c2hsDdcI6DMokMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id].vue?macro=true";
import { default as index0CyOuQ3pXjx8S58Muvm1m4bk0txip9Rg_sIJu5GJWXMMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/index.vue?macro=true";
import { default as participantMailsHY8dB1VxWzcSg0BuLHOlb28EMAGil8GK_fGbzr88fEsMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participants/[id]/participantMails.vue?macro=true";
import { default as participantAnswersl8B9xvclRUVLD2_4552dW1IMTJbune1W1wrEjqq22UuF0Meta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participants/[id]/participantAnswers.vue?macro=true";
import { default as participantBaseDataU_45_XtgRgB4kUNvsara_PHWK7BfjvKgGOjszbgRPp7IAMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participants/[id]/participantBaseData.vue?macro=true";
import { default as participantGuardiansY1NZnSi2jGE9YSxRxnwCmUTeB4OIwKSc25VUcGBocIsMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participants/[id]/participantGuardians.vue?macro=true";
import { default as participantActivitieswEiVkGbaKBm0KZw4nYCOXK_ufSVn8eOBzBvH1wrsS8wMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participants/[id]/participantActivities.vue?macro=true";
import { default as participantSubmissionsEfzcPCHQDbPmAIraQudinbbyRT_i_kLWsW2bQ1H9Sx0Meta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participants/[id]/participantSubmissions.vue?macro=true";
import { default as participantEmergencyContactsbTirmmj8RDb6RsuGQ0IxVqt1_l2PPP7VVmOa_CK4BgsMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participants/[id]/participantEmergencyContacts.vue?macro=true";
import { default as participantTemporaryAccessesu6W_7spOTMxIUgauQVMZsuO3muv_BwnVbT_45ODf_0Mn0Meta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participants/[id]/participantTemporaryAccesses.vue?macro=true";
import { default as _91id_93HTCZdytLfDqNeVu2ixsbrjTtLh2Bhw3hJ38kj_lw9coMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participants/[id].vue?macro=true";
import { default as groupBaseDataI4tc3htjSQEKYbvXCj4c49s2CYmnQQ_45njavSr2i4K34Meta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participantGroups/[id]/groupBaseData.vue?macro=true";
import { default as groupActivitiesXGeJjQCHGKXdpla_KBmjYtXmZg5Yyx3ayyro4dbuwhsMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participantGroups/[id]/groupActivities.vue?macro=true";
import { default as groupParticipantsbutuWa2HvPpFttbRR2GJzXmSsieiRCHVWqBEiwNuKFMMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participantGroups/[id]/groupParticipants.vue?macro=true";
import { default as groupTemporaryAccessesyfC2OBgW8KnwlpGJ6Uuw3YljZD0iZqqFVQmZsvhckwEMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participantGroups/[id]/groupTemporaryAccesses.vue?macro=true";
import { default as _91id_93ghom_45PzNs9KnAAQFM67mSp8peuLLrh2owbXUJWGRiBMMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participantGroups/[id].vue?macro=true";
import { default as eventsS6oZ_45IMoXdweQq_456b2jRpGCFcMaNMpP2ZCXeK3QfY6oMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events.vue?macro=true";
import { default as rolesR15XLIjv6Ran1nWdQLn2A2y3bORY1I6sPfc5_HhPDy8Meta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/roles.vue?macro=true";
import { default as userBaseDataBRs3aUW3gAmQ76qPnF3IOSSiyR_LmTw9890DXBsLd_45cMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/users/[id]/userBaseData.vue?macro=true";
import { default as userActivitiesi8SB3hVstkIPtCsL95l9cWmLXfnpiKEMkQErNX8etTEMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/users/[id]/userActivities.vue?macro=true";
import { default as _91id_93Wa07oTpQE1iM_faGEMiyfMw8xrWtVT3kZ641qgPtorQMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/users/[id].vue?macro=true";
import { default as index7I3vp43gMPMIkVlw45orCSOpqFvVpNCwwuZhg8EVJ0IMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/users/index.vue?macro=true";
import { default as usersJ7_ndSpTvZzIcIpTcUnp8tqDO_8sLqLPp9luEPYsxe0Meta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/users.vue?macro=true";
import { default as baseDatagthOUNoQNlpzECBenK7mSgX2CdW_YRap0ftWkHG4g3AMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/baseData.vue?macro=true";
import { default as billingsGzhLXpzfoheme3AbUtWhysgIPBi0eNSkOKxOv6yDqHwMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/billings.vue?macro=true";
import { default as organisationUsersb9y69oBhiQYDe8FqG2arC2r7nHqUeeYoeb4MO_ddmd8Meta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/organisations/[id]/organisationUsers.vue?macro=true";
import { default as organisationPackageVHFATcWYmRVsEYY6_45fAGJAoPbMXxYkOU_1L93DAyrZUMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/organisations/[id]/organisationPackage.vue?macro=true";
import { default as organisationBaseDatable4fMo4Sqj0lbGFCBxh5oufRRaYeqw1rIOXC1PHk5MMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationActivitiesh9PwFPLrgsy6gaqXpe6Xrt98o3hTSuCozZSOssrcrEMMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationSystemData43qM1bN99oRwk6WUjByGxvRq3qcTCmIZd4HsuQjeGbMMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/organisations/[id]/organisationSystemData.vue?macro=true";
import { default as organisationMailSettingsPXsG98L2N8qhzkHB6sHVOf0_45n52AemENJdf7Tdb8RwgMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/organisations/[id]/organisationMailSettings.vue?macro=true";
import { default as _91id_939Hwslfyl8QscdKQuf1FOpR2CQ_45BcHdq_45aiXHBTwKIYwMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/organisations/[id].vue?macro=true";
import { default as indexYMMU_45Ssn3cQXpdSLMI4rc5a5h7USI9bOgnWkefTzXXgMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/organisations/index.vue?macro=true";
import { default as organisationswlMOevz3QMiv6K_45b7XnFuQp32Mt6en_p68nvQKEvORYMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/organisations.vue?macro=true";
import { default as poolQuestions_rbG1CkYv2bilP40OgIGtfQF8kUVfIoS3oLaT8aKuoQMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/poolQuestions.vue?macro=true";
import { default as indexfBIPF5NMvuiojV5Y4JyTbzerowSK6PrmRdbmUzfttg0Meta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/mailTemplates/index.vue?macro=true";
import { default as mailTemplateBaseDatahO63r3DN5vpXNiFH4AHmNuqcpBavRPPX3rOAScK5drEMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as systemsjBxnrattXTyikTRLJWgN3rup05vJhPbL_8Qx9Ed0zgMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system.vue?macro=true";
import { default as userBaseDataPx_RAxWVOWPh2X5qmk_4521pgwhHPtG8NbLFFVTkSy_cwMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal/users/[id]/userBaseData.vue?macro=true";
import { default as userActivitiesmwu7gu5gZVvqwpt1sT_45XC_RraTveUWDB_45Z4lmUEULswMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal/users/[id]/userActivities.vue?macro=true";
import { default as _91id_93UMERN8pckQDs_45H9qT8IuSKGVswiggmGbUwGjPZn9kmQMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal/users/[id].vue?macro=true";
import { default as organisationUsers5r8_UAsde9SW3T3F4j_qcUWbpkyCQeAEAd0GecIJamwMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal/organisation/organisationUsers.vue?macro=true";
import { default as organisationPackagefYk6EHymhGL5t2pp7bmfb3zAm0vuVN7_IkI82bMCtM4Meta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal/organisation/organisationPackage.vue?macro=true";
import { default as organisationBaseDataPYbttZMUgM2IBeH6ZVgEnPNQT8mlzbikiP_45yh3ap_45zIMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal/organisation/organisationBaseData.vue?macro=true";
import { default as organisationMailSettingsBzUWkxhqF9dzvncazaWBXXMDxbmQ7dVeGk_457XpNql0cMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal/organisation/organisationMailSettings.vue?macro=true";
import { default as organisationYduUlC_wOr8jbPhTtQAg5RTsEn6cDcZNKR7uPIxPOeoMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal/organisation.vue?macro=true";
import { default as mailTemplateBaseDatawchXZHtHo4D5SHsX_XdJuy0AiqLV1tHq0TkbqAHK3KoMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as internalfEpxb_prqzeECfu1bAJ0mH__453CNfpIsrSy40pU13jYEMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal.vue?macro=true";
import { default as _91id_931oqCp4CLUbaug4W8vOnH_p_rx0n5PyCAqQsov2Xv1m0Meta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/crisisManagers/[id].vue?macro=true";
import { default as _91id_93hZ7QawaNG_r3nFHMuRdya2VB_45Fp3LWJkF03QGUoSsfQMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/loginProviders/[id].vue?macro=true";
import { default as indexzp_45ewuE6iZOLO18CuDaDTItko0y5kV9HJIEF4Kx9EwMMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/crisisManagers/index.vue?macro=true";
import { default as indexkwEMpF4zkmRU_45qq3WNwBAoJoTA3LJqaIQgd5Thdof5EMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/loginProviders/index.vue?macro=true";
import { default as settings_45fH6bDFnRvyWYAVkkYw4LP9rO7oz1j_45vktU1ZLrrunUMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings.vue?macro=true";
import { default as setBaseDataPWW5BosprgyZB_Y89hMBZg4QvY_8utA_kkyOViO_45KncMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/questions/sets/[id]/setBaseData.vue?macro=true";
import { default as _91id_93LTt7UrcQloMZb3TXTP2kaXBwTrEXuz8bsF1ckjDo6swMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/questions/sets/[id].vue?macro=true";
import { default as indexoYXQXeSlJozzR9reoqYJhCe5SEYgq9uJoWXJNAJj7MkMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/questions/sets/index.vue?macro=true";
import { default as setsZzYhAMnuG4gFjb13Kk4fO5p0CJHm9WvBFfCCQoYYn8QMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/questions/sets.vue?macro=true";
import { default as questionsdXzvhaEwCsmECNNba0eI6oVQRjLK29ZRHqy0ZIRvZ34Meta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/questions.vue?macro=true";
import { default as index5EmhqgKug_45U91YzvpDYo_45iMURtt9KGuytNf01te_5VEMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/auth/index.vue?macro=true";
import { default as inputsEl6k4YFjnDHEVyb6v6IcTXwlwZSnM_lhb_C6HZSZf2EMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/secret/index/inputs.vue?macro=true";
import { default as mosaic31MzqZM_Ij2BtpUtMDuRflZFJLMo923AJDFeSpe6GFYMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/secret/index/mosaic.vue?macro=true";
import { default as dungeonGXHVXBfv8Guj_45fwcLY4iikDaSgurqvLX7hterSpgahwMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/secret/index/dungeon.vue?macro=true";
import { default as componentseOYEiDcOeu3QJtc25FyLwUegUtQFe1cJrk7FYPC34DEMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/secret/index/components.vue?macro=true";
import { default as indexwkA7rr42DcP9tg8A5g728Ufqbs9aWMX5HyGiu6jeCvcMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/secret/index.vue?macro=true";
import { default as registern_AQLjQ5Dz1yofTxkgd1azgEk1dTAw1KhVvdZeuPVUMMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/auth/register.vue?macro=true";
import { default as _91leader_93Tjh6T20X41dytU4oDESMGY_jGao6wSQhuGBOYO1Wz5UMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/external/event/[event]/leader/[leader].vue?macro=true";
import { default as _91emergency_93wAMX9Uf89TYV_D6fAsYSULXup9myhc5eUjEzVjaa6ZQMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/external/event/[event]/emergency/[emergency].vue?macro=true";
import { default as _91temporary_93O5zs7HMU4ZOeIorXOADkhDfIpnU9xExzn9hr94b42Z8Meta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/external/event/[event]/temporary/[temporary].vue?macro=true";
import { default as _91event_93HgZ0S41sMTAiz3ZO2pAPyG2GXULKLTLKggFz74Upi_UMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/external/event/[event].vue?macro=true";
import { default as eventtxvdQB74H2MkIgykiAXmZ5hXJ8NurERKCtny4ANWyYQMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/external/event.vue?macro=true";
import { default as indexmz_x3tp4fObk25dRuCLDOa15ThuZhh9qnm3hmeOPXPEMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/auth/amos/[organisation]/index.vue?macro=true";
import { default as indexyXv2V09Yt8A5yTzZDerWeizsGCLfYt__wFDCFy3BltcMeta } from "/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/auth/social/[organisation]/index.vue?macro=true";
export default [
  {
    name: "form",
    path: "/form",
    meta: formMe_RNGdmCo_45hLmS1bDdd8QQnuaNjYiUfI9Ie2Xw3hZEMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/form.vue"),
    children: [
  {
    name: "form-event",
    path: ":event()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/form/[event].vue"),
    children: [
  {
    name: "form-event-participant-participant",
    path: "participant/:participant()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/form/[event]/participant/[participant].vue")
  }
]
  },
  {
    name: "form-signatures-signature",
    path: "signatures/:signature()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/form/signatures/[signature].vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/index.vue")
  },
  {
    name: mails1F4sS5lR2v4RQ5dc7OVGn9EMui2YESb3S3hxAXkU4VsMeta?.name,
    path: "/mails",
    meta: mails1F4sS5lR2v4RQ5dc7OVGn9EMui2YESb3S3hxAXkU4VsMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/mails.vue"),
    children: [
  {
    name: "mails-id",
    path: ":id()",
    meta: { ...(_91id_93xGy0S8UpvsC8KL_9PLAKZpxpT_45wQQo_rWXPnXV_454o4kMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/mails/[id].vue"),
    children: [
  {
    name: "mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/mails/[id]/mailBaseData.vue")
  },
  {
    name: "mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/mails/[id]/mailActivities.vue")
  }
]
  },
  {
    name: "mails",
    path: "",
    meta: { ...(indexWG5ImDQkUdyk7O_45TkFMlPXFcz7W9tnOsNYZu1UKoPAsMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/mails/index.vue")
  }
]
  },
  {
    name: eventsS6oZ_45IMoXdweQq_456b2jRpGCFcMaNMpP2ZCXeK3QfY6oMeta?.name,
    path: "/events",
    meta: eventsS6oZ_45IMoXdweQq_456b2jRpGCFcMaNMpP2ZCXeK3QfY6oMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events.vue"),
    children: [
  {
    name: "events-id",
    path: ":id()",
    meta: _91id_93up_aCm91BhgPW7L1ztTx7j22YSyof9c2hsDdcI6DMokMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id].vue"),
    children: [
  {
    name: "events-id-eventMails",
    path: "eventMails",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id]/eventMails.vue")
  },
  {
    name: "events-id-eventLeaders",
    path: "eventLeaders",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id]/eventLeaders.vue")
  },
  {
    name: "events-id-eventBaseData",
    path: "eventBaseData",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id]/eventBaseData.vue")
  },
  {
    name: "events-id-eventQuestions",
    path: "eventQuestions",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id]/eventQuestions.vue")
  },
  {
    name: "events-id-eventActivities",
    path: "eventActivities",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id]/eventActivities.vue")
  },
  {
    name: "events-id-eventParticipants",
    path: "eventParticipants",
    meta: eventParticipants1KCeokhyiGwnhUero_PP7t8ocQS3y_kHvDaekbTJXrwMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id]/eventParticipants.vue")
  },
  {
    name: "events-id-eventCrisisManagers",
    path: "eventCrisisManagers",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id]/eventCrisisManagers.vue")
  },
  {
    name: "events-id-eventParticipantGroups",
    path: "eventParticipantGroups",
    meta: eventParticipantGroupshBrAzZJD3vZSG5dD_aqFPMdpPRc1O8DhjqWC8cfDAHQMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id]/eventParticipantGroups.vue")
  },
  {
    name: "events-id-eventTemporaryAccesses",
    path: "eventTemporaryAccesses",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[id]/eventTemporaryAccesses.vue")
  }
]
  },
  {
    name: "events",
    path: "",
    meta: { ...(index0CyOuQ3pXjx8S58Muvm1m4bk0txip9Rg_sIJu5GJWXMMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/index.vue")
  },
  {
    name: "events-event-participants-id",
    path: ":event()/participants/:id()",
    meta: _91id_93HTCZdytLfDqNeVu2ixsbrjTtLh2Bhw3hJ38kj_lw9coMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participants/[id].vue"),
    children: [
  {
    name: "events-event-participants-id-participantMails",
    path: "participantMails",
    meta: participantMailsHY8dB1VxWzcSg0BuLHOlb28EMAGil8GK_fGbzr88fEsMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participants/[id]/participantMails.vue")
  },
  {
    name: "events-event-participants-id-participantAnswers",
    path: "participantAnswers",
    meta: participantAnswersl8B9xvclRUVLD2_4552dW1IMTJbune1W1wrEjqq22UuF0Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participants/[id]/participantAnswers.vue")
  },
  {
    name: "events-event-participants-id-participantBaseData",
    path: "participantBaseData",
    meta: participantBaseDataU_45_XtgRgB4kUNvsara_PHWK7BfjvKgGOjszbgRPp7IAMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participants/[id]/participantBaseData.vue")
  },
  {
    name: "events-event-participants-id-participantGuardians",
    path: "participantGuardians",
    meta: participantGuardiansY1NZnSi2jGE9YSxRxnwCmUTeB4OIwKSc25VUcGBocIsMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participants/[id]/participantGuardians.vue")
  },
  {
    name: "events-event-participants-id-participantActivities",
    path: "participantActivities",
    meta: participantActivitieswEiVkGbaKBm0KZw4nYCOXK_ufSVn8eOBzBvH1wrsS8wMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participants/[id]/participantActivities.vue")
  },
  {
    name: "events-event-participants-id-participantSubmissions",
    path: "participantSubmissions",
    meta: participantSubmissionsEfzcPCHQDbPmAIraQudinbbyRT_i_kLWsW2bQ1H9Sx0Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participants/[id]/participantSubmissions.vue")
  },
  {
    name: "events-event-participants-id-participantEmergencyContacts",
    path: "participantEmergencyContacts",
    meta: participantEmergencyContactsbTirmmj8RDb6RsuGQ0IxVqt1_l2PPP7VVmOa_CK4BgsMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participants/[id]/participantEmergencyContacts.vue")
  },
  {
    name: "events-event-participants-id-participantTemporaryAccesses",
    path: "participantTemporaryAccesses",
    meta: participantTemporaryAccessesu6W_7spOTMxIUgauQVMZsuO3muv_BwnVbT_45ODf_0Mn0Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participants/[id]/participantTemporaryAccesses.vue")
  }
]
  },
  {
    name: "events-event-participantGroups-id",
    path: ":event()/participantGroups/:id()",
    meta: _91id_93ghom_45PzNs9KnAAQFM67mSp8peuLLrh2owbXUJWGRiBMMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participantGroups/[id].vue"),
    children: [
  {
    name: "events-event-participantGroups-id-groupBaseData",
    path: "groupBaseData",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participantGroups/[id]/groupBaseData.vue")
  },
  {
    name: "events-event-participantGroups-id-groupActivities",
    path: "groupActivities",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participantGroups/[id]/groupActivities.vue")
  },
  {
    name: "events-event-participantGroups-id-groupParticipants",
    path: "groupParticipants",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participantGroups/[id]/groupParticipants.vue")
  },
  {
    name: "events-event-participantGroups-id-groupTemporaryAccesses",
    path: "groupTemporaryAccesses",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/events/[event]/participantGroups/[id]/groupTemporaryAccesses.vue")
  }
]
  }
]
  },
  {
    name: "system",
    path: "/system",
    meta: systemsjBxnrattXTyikTRLJWgN3rup05vJhPbL_8Qx9Ed0zgMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system.vue"),
    children: [
  {
    name: "system-roles",
    path: "roles",
    meta: rolesR15XLIjv6Ran1nWdQLn2A2y3bORY1I6sPfc5_HhPDy8Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/roles.vue")
  },
  {
    name: usersJ7_ndSpTvZzIcIpTcUnp8tqDO_8sLqLPp9luEPYsxe0Meta?.name,
    path: "users",
    meta: usersJ7_ndSpTvZzIcIpTcUnp8tqDO_8sLqLPp9luEPYsxe0Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/users.vue"),
    children: [
  {
    name: "system-users-id",
    path: ":id()",
    meta: { ...(_91id_93Wa07oTpQE1iM_faGEMiyfMw8xrWtVT3kZ641qgPtorQMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/users/[id].vue"),
    children: [
  {
    name: "system-users-id-userBaseData",
    path: "userBaseData",
    meta: userBaseDataBRs3aUW3gAmQ76qPnF3IOSSiyR_LmTw9890DXBsLd_45cMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/users/[id]/userBaseData.vue")
  },
  {
    name: "system-users-id-userActivities",
    path: "userActivities",
    meta: userActivitiesi8SB3hVstkIPtCsL95l9cWmLXfnpiKEMkQErNX8etTEMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/users/[id]/userActivities.vue")
  }
]
  },
  {
    name: "system-users",
    path: "",
    meta: { ...(index7I3vp43gMPMIkVlw45orCSOpqFvVpNCwwuZhg8EVJ0IMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/users/index.vue")
  }
]
  },
  {
    name: "system-baseData",
    path: "baseData",
    meta: baseDatagthOUNoQNlpzECBenK7mSgX2CdW_YRap0ftWkHG4g3AMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/baseData.vue")
  },
  {
    name: "system-billings",
    path: "billings",
    meta: billingsGzhLXpzfoheme3AbUtWhysgIPBi0eNSkOKxOv6yDqHwMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/billings.vue")
  },
  {
    name: organisationswlMOevz3QMiv6K_45b7XnFuQp32Mt6en_p68nvQKEvORYMeta?.name,
    path: "organisations",
    meta: organisationswlMOevz3QMiv6K_45b7XnFuQp32Mt6en_p68nvQKEvORYMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/organisations.vue"),
    children: [
  {
    name: "system-organisations-id",
    path: ":id()",
    meta: { ...(_91id_939Hwslfyl8QscdKQuf1FOpR2CQ_45BcHdq_45aiXHBTwKIYwMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/organisations/[id].vue"),
    children: [
  {
    name: "system-organisations-id-organisationUsers",
    path: "organisationUsers",
    meta: organisationUsersb9y69oBhiQYDe8FqG2arC2r7nHqUeeYoeb4MO_ddmd8Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/organisations/[id]/organisationUsers.vue")
  },
  {
    name: "system-organisations-id-organisationPackage",
    path: "organisationPackage",
    meta: organisationPackageVHFATcWYmRVsEYY6_45fAGJAoPbMXxYkOU_1L93DAyrZUMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/organisations/[id]/organisationPackage.vue")
  },
  {
    name: "system-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    meta: organisationBaseDatable4fMo4Sqj0lbGFCBxh5oufRRaYeqw1rIOXC1PHk5MMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "system-organisations-id-organisationActivities",
    path: "organisationActivities",
    meta: organisationActivitiesh9PwFPLrgsy6gaqXpe6Xrt98o3hTSuCozZSOssrcrEMMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "system-organisations-id-organisationSystemData",
    path: "organisationSystemData",
    meta: organisationSystemData43qM1bN99oRwk6WUjByGxvRq3qcTCmIZd4HsuQjeGbMMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/organisations/[id]/organisationSystemData.vue")
  },
  {
    name: "system-organisations-id-organisationMailSettings",
    path: "organisationMailSettings",
    meta: organisationMailSettingsPXsG98L2N8qhzkHB6sHVOf0_45n52AemENJdf7Tdb8RwgMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/organisations/[id]/organisationMailSettings.vue")
  }
]
  },
  {
    name: "system-organisations",
    path: "",
    meta: { ...(indexYMMU_45Ssn3cQXpdSLMI4rc5a5h7USI9bOgnWkefTzXXgMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/organisations/index.vue")
  }
]
  },
  {
    name: "system-poolQuestions",
    path: "poolQuestions",
    meta: poolQuestions_rbG1CkYv2bilP40OgIGtfQF8kUVfIoS3oLaT8aKuoQMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/poolQuestions.vue")
  },
  {
    name: "system-mailTemplates",
    path: "mailTemplates",
    meta: { ...(indexfBIPF5NMvuiojV5Y4JyTbzerowSK6PrmRdbmUzfttg0Meta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/mailTemplates/index.vue")
  },
  {
    name: "system-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplates/:id()/mailTemplateBaseData",
    meta: { ...(mailTemplateBaseDatahO63r3DN5vpXNiFH4AHmNuqcpBavRPPX3rOAScK5drEMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/system/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settings_45fH6bDFnRvyWYAVkkYw4LP9rO7oz1j_45vktU1ZLrrunUMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings.vue"),
    children: [
  {
    name: "settings-internal",
    path: "internal",
    meta: internalfEpxb_prqzeECfu1bAJ0mH__453CNfpIsrSy40pU13jYEMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal.vue"),
    children: [
  {
    name: "settings-internal-users-id",
    path: "users/:id()",
    meta: { ...(_91id_93UMERN8pckQDs_45H9qT8IuSKGVswiggmGbUwGjPZn9kmQMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal/users/[id].vue"),
    children: [
  {
    name: "settings-internal-users-id-userBaseData",
    path: "userBaseData",
    meta: userBaseDataPx_RAxWVOWPh2X5qmk_4521pgwhHPtG8NbLFFVTkSy_cwMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-internal-users-id-userActivities",
    path: "userActivities",
    meta: userActivitiesmwu7gu5gZVvqwpt1sT_45XC_RraTveUWDB_45Z4lmUEULswMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal/users/[id]/userActivities.vue")
  }
]
  },
  {
    name: "settings-internal-organisation",
    path: "organisation",
    meta: { ...(organisationYduUlC_wOr8jbPhTtQAg5RTsEn6cDcZNKR7uPIxPOeoMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal/organisation.vue"),
    children: [
  {
    name: "settings-internal-organisation-organisationUsers",
    path: "organisationUsers",
    meta: organisationUsers5r8_UAsde9SW3T3F4j_qcUWbpkyCQeAEAd0GecIJamwMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal/organisation/organisationUsers.vue")
  },
  {
    name: "settings-internal-organisation-organisationPackage",
    path: "organisationPackage",
    meta: organisationPackagefYk6EHymhGL5t2pp7bmfb3zAm0vuVN7_IkI82bMCtM4Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal/organisation/organisationPackage.vue")
  },
  {
    name: "settings-internal-organisation-organisationBaseData",
    path: "organisationBaseData",
    meta: organisationBaseDataPYbttZMUgM2IBeH6ZVgEnPNQT8mlzbikiP_45yh3ap_45zIMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal/organisation/organisationBaseData.vue")
  },
  {
    name: "settings-internal-organisation-organisationMailSettings",
    path: "organisationMailSettings",
    meta: organisationMailSettingsBzUWkxhqF9dzvncazaWBXXMDxbmQ7dVeGk_457XpNql0cMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal/organisation/organisationMailSettings.vue")
  }
]
  },
  {
    name: "settings-internal-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplates/:id()/mailTemplateBaseData",
    meta: { ...(mailTemplateBaseDatawchXZHtHo4D5SHsX_XdJuy0AiqLV1tHq0TkbqAHK3KoMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/internal/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "settings-crisisManagers-id",
    path: "crisisManagers/:id()",
    meta: { ...(_91id_931oqCp4CLUbaug4W8vOnH_p_rx0n5PyCAqQsov2Xv1m0Meta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/crisisManagers/[id].vue")
  },
  {
    name: "settings-loginProviders-id",
    path: "loginProviders/:id()",
    meta: { ...(_91id_93hZ7QawaNG_r3nFHMuRdya2VB_45Fp3LWJkF03QGUoSsfQMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/loginProviders/[id].vue")
  },
  {
    name: "settings-crisisManagers",
    path: "crisisManagers",
    meta: { ...(indexzp_45ewuE6iZOLO18CuDaDTItko0y5kV9HJIEF4Kx9EwMMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/crisisManagers/index.vue")
  },
  {
    name: "settings-loginProviders",
    path: "loginProviders",
    meta: { ...(indexkwEMpF4zkmRU_45qq3WNwBAoJoTA3LJqaIQgd5Thdof5EMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: "questions",
    path: "/questions",
    meta: questionsdXzvhaEwCsmECNNba0eI6oVQRjLK29ZRHqy0ZIRvZ34Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/questions.vue"),
    children: [
  {
    name: setsZzYhAMnuG4gFjb13Kk4fO5p0CJHm9WvBFfCCQoYYn8QMeta?.name,
    path: "sets",
    meta: setsZzYhAMnuG4gFjb13Kk4fO5p0CJHm9WvBFfCCQoYYn8QMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/questions/sets.vue"),
    children: [
  {
    name: "questions-sets-id",
    path: ":id()",
    meta: { ...(_91id_93LTt7UrcQloMZb3TXTP2kaXBwTrEXuz8bsF1ckjDo6swMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/questions/sets/[id].vue"),
    children: [
  {
    name: "questions-sets-id-setBaseData",
    path: "setBaseData",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/questions/sets/[id]/setBaseData.vue")
  }
]
  },
  {
    name: "questions-sets",
    path: "",
    meta: { ...(indexoYXQXeSlJozzR9reoqYJhCe5SEYgq9uJoWXJNAJj7MkMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/questions/sets/index.vue")
  }
]
  }
]
  },
  {
    name: "auth",
    path: "/auth",
    meta: index5EmhqgKug_45U91YzvpDYo_45iMURtt9KGuytNf01te_5VEMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/auth/index.vue")
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/secret/index/inputs.vue")
  },
  {
    name: "secret-index-mosaic",
    path: "mosaic",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/secret/index/mosaic.vue")
  },
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-components",
    path: "components",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/secret/index/components.vue")
  }
]
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: registern_AQLjQ5Dz1yofTxkgd1azgEk1dTAw1KhVvdZeuPVUMMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/auth/register.vue")
  },
  {
    name: "external-event",
    path: "/external/event",
    meta: eventtxvdQB74H2MkIgykiAXmZ5hXJ8NurERKCtny4ANWyYQMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/external/event.vue"),
    children: [
  {
    name: "external-event-event",
    path: ":event()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/external/event/[event].vue"),
    children: [
  {
    name: "external-event-event-leader-leader",
    path: "leader/:leader()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/external/event/[event]/leader/[leader].vue")
  },
  {
    name: "external-event-event-emergency-emergency",
    path: "emergency/:emergency()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/external/event/[event]/emergency/[emergency].vue")
  },
  {
    name: "external-event-event-temporary-temporary",
    path: "temporary/:temporary()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/external/event/[event]/temporary/[temporary].vue")
  }
]
  }
]
  },
  {
    name: "auth-amos-organisation",
    path: "/auth/amos/:organisation()",
    meta: indexmz_x3tp4fObk25dRuCLDOa15ThuZhh9qnm3hmeOPXPEMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/auth/amos/[organisation]/index.vue")
  },
  {
    name: "auth-social-organisation",
    path: "/auth/social/:organisation()",
    meta: indexyXv2V09Yt8A5yTzZDerWeizsGCLfYt__wFDCFy3BltcMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/81433128/client/pages/auth/social/[organisation]/index.vue")
  }
]